import { render, staticRenderFns } from "./LotDetails.vue?vue&type=template&id=55606a57&scoped=true&"
import script from "./LotDetails.vue?vue&type=script&lang=js&"
export * from "./LotDetails.vue?vue&type=script&lang=js&"
import style0 from "./LotDetails.vue?vue&type=style&index=0&id=55606a57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55606a57",
  null
  
)

export default component.exports